import React, { Fragment } from 'react'

export const UsersComponent = ({users, loading}) => {
    return (
      <Fragment>
        <div className="dashboard-card">
          <table className="table table-dark oi-table">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Username</th>
                <th scope="col">Phone</th>
                <th scope="col">Button</th>
               
              </tr>
            </thead>
            <tbody>
               {users.map((user) => (
              <tr key={user._id}>
                <th scope="row">{user._id.substring(0, 6)}</th>
                <td>{user.username}</td>
                <td>{user.phone_number}</td>
                <td>{user.network}</td>
                
              </tr>
               ))}
            </tbody>
          </table>
        </div>
      </Fragment>
    );
}
